import axiosInstance from "../api/axiosInstance";

/**
 * ============================
 * EMAIL AUTH
 * ============================
 */

// Email login
export const emailLogin = (email, password,userTimeZone) => {
  return axiosInstance.post("/auth_email/email_login", null, {
    params: { email, password,userTimeZone, },
  });
};

// Request signup OTP
export const requestSignupOtp = (email, password, name) => {
  return axiosInstance.post("/auth_email/signup/request", null, {
    params: { email, password, name },
  });
};

// Verify signup OTP
export const verifySignupOtp = (email, otp) => {
  return axiosInstance.post("/auth_email/signup/verify", null, {
    params: { email, otp },
  });
};

/**
 * ============================
 * FORGOT PASSWORD
 * ============================
 */

// Request reset OTP
export const requestPasswordResetOtp = (email) => {
  return axiosInstance.post("/auth_email/forgot_password/request", null, {
    params: { email },
  });
};

// Verify OTP & reset password
export const resetPassword = (email, otp, newPassword) => {
  return axiosInstance.post("/auth_email/forgot_password/verify", null, {
    params: { email, otp, newPassword },
  });
};

/**
 * ============================
 * GOOGLE AUTH
 * ============================
 */

// Google login
export const googleLogin = (idToken,userTimeZone) => {
  return axiosInstance.post("/auth/google", {
    idToken,userTimeZone,
  });
};

/**
 * ============================
 * PROFILE MANAGEMENT
 * ============================
 */

// Get user profile
export const getUserProfile = () => {
  return axiosInstance.get("/user/profile");
};

// Update profile (mobile number, whatsapp preference)
export const updateUserProfile = (data) => {
  return axiosInstance.patch("/user/profile", data);
};
